export default "__VITE_ASSET__BhvZYshR__"